export default __webpack_public_path__ + "static/media/Beans.1aa1bf86.png";